import { ApiUtil as api } from '@/utils/api.util.js'

export class OrderOperationClaimServiceService {
  static URL = process.env.API_URL + process.env.API_VER
  static RESOURCE = '/order-operation-claim-services/'

  static all (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams)
  }

  static listCategories (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'categories', queryParams)
  }

  static listCategoryTags (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'category-tags', queryParams)
  }

  static getClaimServices (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'firm/claim/' + queryParams.id, queryParams)
  }
  static toggleStatus (queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + 'toggle-status/', queryParams)
  }
  static bulkArchive (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'bulk-archive/', queryParams)
  }
  static bulkRestore (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'bulk-restore/', queryParams)
  }
  static uploadData (id, queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'upload-data/' + id, queryParams)
  }
  static import (data = {}) {
    return api.post(this.URL + this.RESOURCE + 'import', data)
  }
  static bulkArchiveCodes (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'bulk-archive-codes', queryParams)
  }
  static bulkRestoreCodes (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'bulk-restore-codes', queryParams)
  }
  static create (data = {}) {
    return api.post(this.URL + this.RESOURCE, data)
  }
  static archiveByParentRate (data = {}) {
    return api.put(this.URL + this.RESOURCE + "archive-by-parent-rate", data)
  }
  static restoreByParentRate (data = {}) {
    return api.put(this.URL + this.RESOURCE + "restore-by-parent-rate", data)
  }
}




// WEBPACK FOOTER //
// ./src/services/orderOperationClaimService.service.js